<script setup>
import { computed, ref, watch } from 'vue'
import { storeToRefs } from 'pinia'
import { useNotificationStore } from '@/stores/helpers/notification.js'
import { useAuthStore } from '@/stores/retailer/auth.js'
import {
  isSystemNotificationFlowItem,
  useSystemNotificationFlowStore
} from '@/stores/retailer/systemNotificationFlow.js'
import SystemNotificationModal from '@/components/systemNotification/SystemNotificationModal.vue'
import SystemNotificationWelcomeModal from '@/components/systemNotification/SystemNotificationWelcomeModal.vue'

const notificationStore = useNotificationStore()
const authStore = useAuthStore()
const systemNotificationFlowStore = useSystemNotificationFlowStore()

const { notifications } = storeToRefs(notificationStore)
const { user } = storeToRefs(authStore)
const {
  currentNotification,
  currentIndex,
  totalCount,
  isWelcomeVisible,
  isFlowVisible,
  isClosable,
  isMultiple,
  isFirst,
  isLast,
  severityCounts
} = storeToRefs(systemNotificationFlowStore)

// Keeps the last notification rendered while the modal fades out after the flow is finished.
const displayedNotification = ref(null)

const userName = computed(() => [user.value?.firstname, user.value?.lastname].filter(Boolean).join(' '))

const step = computed(() => currentIndex.value + 1)

watch(currentNotification, notification => {
  if (notification) {
    displayedNotification.value = notification
  }
})

watch(
  () => notifications.value.filter(isSystemNotificationFlowItem),
  flowNotifications => systemNotificationFlowStore.enqueue(flowNotifications),
  { immediate: true }
)
</script>

<template>
  <system-notification-welcome-modal
    :is-showing="isWelcomeVisible"
    :user-name="userName"
    :total-count="totalCount"
    :severity-counts="severityCounts"
    @close="systemNotificationFlowStore.postpone"
    @review="systemNotificationFlowStore.review"
  />

  <system-notification-modal
    v-if="displayedNotification !== null"
    :notification="displayedNotification"
    :is-showing="isFlowVisible"
    :is-closable="isClosable"
    :is-multiple="isMultiple"
    :is-first="isFirst"
    :is-last="isLast"
    :step="step"
    :total="totalCount"
    @close="systemNotificationFlowStore.finish"
    @confirm="systemNotificationFlowStore.finish"
    @next="systemNotificationFlowStore.next"
    @previous="systemNotificationFlowStore.previous"
  />
</template>
